import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from "@mui/material";
import { StyledTableRow } from "../../../../../styles/Shipmentstyles";
import AppTableHeaderCell from "../../../../../views/components/common/pages/AppTableHeaderCell";
import AppTableRowCell from "../../../../../views/components/common/pages/AppTableRowCell";
import { OwnerSalesRow } from "../../../../../models/Dashboard/SalesDashboard/SalesAnalytics";
import { CurrencyHelper } from "../../../../../utils/CurrencyHelper";

interface OwnerSalesRowTableProps {
  data: OwnerSalesRow[];
}

const OwnerSalesRowTable = ({ data }: OwnerSalesRowTableProps) => {
  const theme = useTheme();

  return (
    <>
      <TableContainer style={{ height: "100%", maxHeight: "100%" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <AppTableHeaderCell
                minWidth="80px"
                title="S.No"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
              <AppTableHeaderCell
                minWidth="80px"
                title="OWNER ID"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
              <AppTableHeaderCell
                minWidth="300px"
                title="OWNER"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
              <AppTableHeaderCell
                title="REVENUE (₹)"
                minWidth="200px"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
              <AppTableHeaderCell
                title="REVENUE IN SHORT"
                minWidth="200px"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
              <AppTableHeaderCell
                title="INBOUND"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
              <AppTableHeaderCell
                title="OUTBOUND"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
              <AppTableHeaderCell
                title="MEETINGS"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((item: OwnerSalesRow, index: number) => (
              <StyledTableRow key={item.owner_id}>
                <AppTableRowCell minWidth="80px">{index + 1}</AppTableRowCell>
                <AppTableRowCell minWidth="80px">
                  {item.owner_id}
                </AppTableRowCell>
                <AppTableRowCell minWidth="300px">
                  {item.owner_name}
                </AppTableRowCell>

                <AppTableRowCell>{item.total_revenue ?? 0}</AppTableRowCell>

                <AppTableRowCell>
                  {CurrencyHelper.formatIndianNumber(item.total_revenue)}
                </AppTableRowCell>

                <AppTableRowCell>{item.inbound_count ?? 0}</AppTableRowCell>

                <AppTableRowCell>{item.outbound_count ?? 0}</AppTableRowCell>
                <AppTableRowCell>{item.meetings_count ?? 0}</AppTableRowCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default OwnerSalesRowTable;
